// src/pages/Ilan_Yayinlarken_Dikkat_Edilmesi_Gerekenler.jsx
import React, { useState } from "react";

const Ilan_Yayinlarken_Dikkat_Edilmesi_Gerekenler = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (itemId) => {
    setOpenItems(prev => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));
  };

  const sections = [
    {
      id: 1,
      title: "1. Başlık (Proje Adı)",
      content: "İlan başlığı, yapılmakta olan veya yapım aşamasındaki projenin resmi adıyla oluşturulmalıdır. Başlık, kullanıcıların ilanın hangi proje ve şirkete ait olduğunu kolayca ayırt edebilmesi için kritiktir.",
      points: [
        "Başlıkta yalnızca kelimelerin baş harfleri büyük, diğer harfler küçük olmalıdır.",
        "Örnek: 'Güneşli Konut Projesi'",
        "Kurumsal uyumsuzluk durumunda şirketimiz, ilanı düzeltme, kaldırma veya arşivleme hakkına sahiptir."
      ]
    },
    {
      id: 2,
      title: "2. Fiyat Bilgisi",
      content: "İlan fiyatını girerken nokta, virgül, alt çizgi veya özel karakterler kullanmamalısınız. Fiyat bilgisi yalnızca rakamsal olarak girilmelidir.",
      points: [
        "Kurumsal uyumsuzluk durumunda, ilan üzerinde düzeltme veya güncelleme yapılabilir."
      ]
    },
    {
      id: 3,
      title: "3. Konum Bilgisi (İl ve İlçe)",
      content: "Projenin kayıtlı olduğu il ve ilçe bilgileri doğru ve eksiksiz şekilde girilmelidir.",
      points: [
        "Yanlış veya eksik bilgi verilmesi, kullanıcı deneyimini olumsuz etkileyebilir.",
        "Şirketimiz, yanlış konum bilgisi nedeniyle oluşabilecek sorunlardan sorumlu tutulamaz."
      ]
    },
    {
      id: 4,
      title: "4. Teslim Tarihi",
      content: "Teslim tarihi yalnızca yıl olarak girilmelidir.",
      points: [
        "Ay, gün, saat veya mevsim gibi detaylar eklenmemelidir.",
        "Uygunsuz formatta verilen tarihler, şirketimiz tarafından düzeltilebilir veya ilan kaldırılabilir."
      ]
    },
    {
      id: 5,
      title: "5. Toplam Konut Sayısı",
      content: "Projede yer alan toplam konut sayısı doğru ve eksiksiz olarak belirtilmelidir.",
      points: [
        "Bu bilgi, kullanıcıların projeyi değerlendirmesi açısından kritik öneme sahiptir."
      ]
    },
    {
      id: 6,
      title: "6. Proje Açıklaması",
      content: "Proje açıklaması, kullanıcıların proje hakkında detaylı bilgi edinebilmeleri ve ilgilerini çekebilmek için şirketiniz tarafından eksiksiz ve açık şekilde hazırlanmalıdır.",
      points: [
        "Açıklama, projenin özelliklerini, hedef kitlesini ve öne çıkan noktalarını içermelidir.",
        "Kısa veya eksik açıklamalar, ilan görünürlüğünü ve kullanıcı etkileşimini azaltabilir."
      ]
    },
    {
      id: 7,
      title: "7. Broşür (PDF)",
      content: "Projeye ait detaylı bilgileri içeren broşürleri yalnızca '.pdf' formatında yükleyebilirsiniz.",
      points: [
        "PDF dosyaları, projenin teknik, mimari ve genel özelliklerini içermelidir.",
        "Yanlış formatta dosya yüklenmesi, ilan üzerinde düzeltme veya arşivleme yapılmasına neden olabilir."
      ]
    },
    {
      id: 8,
      title: "8. Resim ve Görseller",
      content: "",
      points: [
        "Projeye ait tüm görseller '.png, .jpg, .jpeg' formatında olmalıdır.",
        "Kat planları veya teknik çizimler bu alana yüklenmemelidir; bunun için ayrı alan mevcuttur.",
        "Görsellerde herhangi bir reklam, logo veya başka proje bilgisi bulunmamalıdır.",
        "Kurumsal uyumsuzluk durumunda, görseller düzeltme, kaldırma veya arşivleme işlemine tabi tutulur."
      ]
    },
    {
      id: 9,
      title: "9. Konum Bilgisi (Google Maps URL)",
      content: "",
      points: [
        "Google Maps üzerinden alınacak konum URL'si doğrudan kopyalanmamalıdır.",
        "İşlem adımları:",
        "1. Google Maps üzerinde projenin konumunu bulun.",
        "2. 'Paylaş' seçeneğine tıklayın.",
        "3. 'Harita Yerleştirme' seçeneğini seçin.",
        "4. Açılan pencerede 'HTML'yi Kopyala' seçeneği ile URL'yi alın.",
        "5. Bu URL'yi platformda belirtilen alana yapıştırın.",
        "Adımların doğru şekilde tamamlanmaması halinde, şirketimiz URL'nin çalışmamasından veya adresin yanlış görüntülenmesinden sorumlu değildir. Şirket, ilan üzerinde düzeltme, güncelleme veya arşivleme haklarına sahiptir."
      ]
    },
    {
      id: 10,
      title: "10. Mimari Açıklama",
      content: "",
      points: [
        "Projenin alanı, daire tipleri, inşaat yapısı, kullanılan malzeme kalitesi gibi teknik bilgiler bu alanda girilmelidir.",
        "Açıklamalar eksiksiz ve doğru olmalıdır; yanlış veya yanıltıcı bilgi, şirketin düzeltme veya ilan kaldırma haklarını tetikler."
      ]
    },
    {
      id: 11,
      title: "11. Daire Tipi ve Alan Bilgileri",
      content: "",
      points: [
        "Her daire tipi için ayrı kayıt oluşturulmalıdır.",
        "Net alan ve brüt alan bilgilerinde özel karakter kullanılmamalıdır.",
        "Balkon var/yok bilgisi doğru şekilde işaretlenmelidir."
      ]
    },
    {
      id: 12,
      title: "12. Kat Planı",
      content: "",
      points: [
        "Kat planı görseli, daireye ait mimari çizimi içermelidir.",
        "Görselde reklam veya başka proje bilgisi bulunmamalıdır.",
        "Aksi takdirde, şirketimiz ilanı kaldırma veya arşivleme hakkına sahiptir."
      ]
    },
    {
      id: 13,
      title: "13. Proje Özellikleri",
      content: "",
      points: [
        "Bina Özellikleri, Dış Özellikler ve Çevre Özellikleri bilgileri bu alanda girilmelidir.",
        "Bu bilgiler, ilanın diğer alanlarında tekrar edilmemelidir."
      ]
    },
    {
      id: 14,
      title: "14. Şirket Bilgisi",
      content: "",
      points: [
        "İlanı giren kurumsal firmanın adı, iletişim bilgileri ve logoları doğru şekilde belirtilmelidir.",
        "Kurumsal kullanıcılar, bilgilerini portal üzerinden güncelleyebilir.",
        "Logo yükleme işlemi, kurumsal portalda belirtilen yönergelere uygun olarak yapılmalıdır."
      ]
    }
  ];

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>İlan Yayınlarken Dikkat Edilmesi Gerekenler</h1>

        <section style={styles.section}>
          <p style={styles.text}>
            Platformumuzda ilan yayınlarken uyulması gereken kurallar ve dikkat edilmesi gereken noktalar, 
            ilanınızın doğru, güvenilir ve etkili bir şekilde kullanıcılar tarafından görüntülenmesini sağlar. 
            Aşağıda her bir alan için açıklamalar ve dikkat edilmesi gereken hususlar detaylı olarak sunulmuştur:
          </p>
        </section>

        <div style={styles.guidelinesContainer}>
          {sections.map((section) => (
            <div key={section.id} style={styles.guidelineItem}>
              <div 
                style={styles.guidelineHeader}
                onClick={() => toggleItem(section.id)}
              >
                <h2 style={styles.guidelineTitle}>{section.title}</h2>
                <span style={styles.icon}>
                  {openItems[section.id] ? '−' : '+'}
                </span>
              </div>
              
              {openItems[section.id] && (
                <div style={styles.guidelineContent}>
                  {section.content && (
                    <p style={styles.guidelineText}>{section.content}</p>
                  )}
                  {section.points.length > 0 && (
                    <ul style={styles.pointsList}>
                      {section.points.map((point, index) => (
                        <li key={index} style={styles.pointItem}>
                          {point}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>

        <section style={styles.importantSection}>
          <h2 style={styles.heading}>Önemli Uyarı</h2>
          <p style={styles.text}>
            Yukarıda belirtilen kurallara uyulmaması durumunda, şirketimiz ilan üzerinde düzeltme, 
            kaldırma veya arşivleme işlemleri yapma hakkını saklı tutar. Kurallara uygun ilan yayınlamak, 
            hem kullanıcı deneyimini iyileştirir hem de platformun güvenilirliğini artırır.
          </p>
          <div style={styles.contactInfo}>
            <p style={styles.text}>
              <strong>Destek için:</strong><br />
              E-posta: <a href="mailto:destek@temelden.com.tr" style={styles.link}>destek@temelden.com.tr</a>
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

const styles = {
  page: {
    backgroundColor: "#f7f7f7",
    minHeight: "100vh",
    padding: "60px 20px",
    display: "flex",
    justifyContent: "center",
  },
  container: {
    maxWidth: "900px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "40px 30px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    lineHeight: "1.7",
  },
  title: {
    fontSize: "24px",
    fontWeight: "700",
    textAlign: "center",
    marginBottom: "30px",
    color: "#222",
  },
  section: {
    marginBottom: "30px",
  },
  heading: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#333",
    marginBottom: "15px",
    borderBottom: "2px solid #f0f0f0",
    paddingBottom: "8px",
  },
  text: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "10px",
  },
  guidelinesContainer: {
    marginBottom: "40px",
  },
  guidelineItem: {
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    marginBottom: "15px",
    overflow: "hidden",
  },
  guidelineHeader: {
    backgroundColor: "#f8f9fa",
    padding: "15px 20px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    transition: "background-color 0.3s ease",
  },
  guidelineTitle: {
    margin: 0,
    fontSize: "16px",
    fontWeight: "600",
    color: "#0056b3",
  },
  icon: {
    fontSize: "18px",
    fontWeight: "bold",
    color: "#0056b3",
  },
  guidelineContent: {
    padding: "20px",
    backgroundColor: "#fff",
  },
  guidelineText: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "15px",
    lineHeight: "1.6",
  },
  pointsList: {
    paddingLeft: "20px",
    margin: 0,
  },
  pointItem: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "8px",
    lineHeight: "1.6",
  },
  importantSection: {
    backgroundColor: "#fff8e1",
    padding: "25px",
    borderRadius: "8px",
    border: "1px solid #ffd54f",
  },
  contactInfo: {
    marginTop: "15px",
    paddingTop: "15px",
    borderTop: "1px solid #ffd54f",
  },
  link: {
    color: "#0056b3",
    textDecoration: "none",
  },
};

// Hover efektleri
styles.guidelineHeader = {
  ...styles.guidelineHeader,
  ":hover": {
    backgroundColor: "#e9ecef",
  },
};

styles.link = {
  ...styles.link,
  ":hover": {
    textDecoration: "underline",
  },
};

export default Ilan_Yayinlarken_Dikkat_Edilmesi_Gerekenler;